<script setup lang="ts">
import { computed } from 'vue';
import { useTenantStore } from '@sera/core';

const props = withDefaults(
  defineProps<{
    maxHeight?: number;
    maxWidth?: number;
    fallback?: 'wordmark' | 'text' | 'none';
  }>(),
  {
    maxHeight: 36,
    maxWidth: 160,
    fallback: 'wordmark',
  },
);

const tenantStore = useTenantStore();
const logoUrl = computed(() => tenantStore.config?.logoUrl);
</script>

<template>
  <img
    v-if="logoUrl"
    :src="logoUrl"
    alt="Logo"
    :style="{ maxHeight: `${maxHeight}px`, maxWidth: `${maxWidth}px` }"
    class="object-contain"
  />
  <span
    v-else-if="fallback === 'text'"
    class="text-white font-bold text-sm tracking-widest"
    >SERA</span
  >
  <template v-else-if="fallback === 'wordmark'">
    <span class="text-foreground font-bold text-xl tracking-tight shrink-0"
      >S</span
    >
    <span
      class="text-foreground font-bold text-xl tracking-tight whitespace-nowrap overflow-hidden"
      >era.</span
    >
  </template>
</template>
